import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';

@Injectable()
export class JsonService {

  constructor(public http: Http) { }

  public getJSON() {
    console.log('aca');
    const headers = new Headers();
    headers.set('Content-Type', 'application/json');

    const options = {headers: headers};
    return new Promise((resolve, reject) => {
      this.http.get('https://cdn.dreamjobs.com.co/json/dreamjobs.json', options)
        .subscribe(res => {
          resolve(res.json());
        }, (err) => {
          console.log(err);
          reject('err.json().meta.message');
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/service/json.service.ts